import React, {useState, useEffect, useRef} from 'react';
import {useVisibility} from "./useVisibility";

type IProps = {
    children: React.ReactNode
};

export const AnimatedToBigger = (props: IProps) => {
    const [scale, setScale] = useState(1);
    const ref = useRef<HTMLDivElement>(null)
    const visibility = useVisibility(ref)

    useEffect(() => {
        const handleScroll = () => {
            if (ref.current!.offsetTop <= window.scrollY && visibility)
                setScale(Math.min(1 + window.scrollY / 1000, 2));
        }

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        }

    }, [ref, visibility])

    const style = {
        transform: `scale(${scale})`,
    }

    return (
        <div style={style} ref={ref}>
            {props.children}
        </div>
    )
};